import { Button } from "antd"
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons"

const ICON_FONT_SIZE = 18

const SidebarToggle = ({ collapsed, onToggle }) => {
  const Icon = collapsed ? MenuUnfoldOutlined : MenuFoldOutlined
  const accessibleLabel = collapsed ? "Expand navigation" : "Collapse navigation"

  return (
    <Button
      type="text"
      onClick={onToggle}
      aria-label={accessibleLabel}
      aria-expanded={!collapsed}
      icon={<Icon style={{ fontSize: ICON_FONT_SIZE }} />}
    />
  )
}

export default SidebarToggle
